import crud from '@/crud/index/index'

import data from './data'
import methods from './methods'
import components from './components'

export default {
  data,
  methods,
  components,
  mixins: [crud],

  resourcePath: 'v1/patient/scheduling/schedules/upcoming'
}



// WEBPACK FOOTER //
// ./src/app/patient/dashboard/gadget/components/upcoming/resources/index.js